export const displayShareDate = (today: Date, shareDate: Date) => {
    const cutOff = 21

    const oneDay = 24 * 60 * 60 * 1000 // hours*minutes*seconds*milliseconds

    const diffDays = Math.floor(Math.abs((today.valueOf() - shareDate.valueOf()) / oneDay))

    if (diffDays > cutOff) {
        const day = shareDate.getDate()
        const month = shareDate.toLocaleString('default', { month: 'short' })
        const year = shareDate.getFullYear()
        return day + ' ' + month + ' ' + year
    } else if (diffDays > 14) {
        return '2 weeks ago'
    } else if (diffDays > 7) {
        return '1 week ago'
    } else if (diffDays === 1) {
        return 'Yesterday'
    } else if (diffDays === 0) {
        return 'Today'
    }

    return shareDate.toLocaleString('default', { weekday: 'long' })
}